// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.field .has-addons a {\n  height: 30px;\n}\n.field-label label{\n  font-size: 0.875rem !important;\n  font-weight: 400;\n}\n#evaluations-resume input,\n#evaluations-resume textarea,\n#evaluations-resume select {\n  background-color: #FFFFFF !important;\n  border-color: #ECEFF4;\n}\n@media screen and (min-width: 992px) {\n.field-label label{\n    text-align: left;\n}\n}\n", ""]);
// Exports
module.exports = exports;
